export const getFileAvatarImg = (filename: string) => {
  let ext = filename.substr(1 + filename.lastIndexOf('.')).toLowerCase();
  if (!['docx', 'pdf', 'xlsx'].includes(ext)) {
    ext = 'txt';
  }

  return "/images/icons/" + ext + ".png";
};
